// src/utils/emailRecipientLine.js
// How the people an email went to read on screen: the review popup before a send, and the Email Log
// afterwards. One address keeps the familiar "Sara Michel <sara@saramichel.com>".
//
// A seller email now carries every client on the file (openHouseSellers.js, Henry 09/24/2026), so
// the name is a joined one and the addresses are a list. Inside angle brackets that looks like one
// broken address, so several addresses read as the name, a colon, then the plain list. Display only:
// the wire header is built from the addresses alone.
export function recipientLine(toName, to) {
  const addresses = String(to || "").trim();
  const name = String(toName || "").trim();
  if (!name || name === addresses) return addresses || name;
  if (!addresses) return name;
  return addresses.includes(",") ? `${name}: ${addresses}` : `${name} <${addresses}>`;
}
